export class ClassQnpMRequestModel {
    classId: number;
    qnpMId: number;
    constructor(classId: number,qnpMId:number) {
        this.classId = classId;
        this.qnpMId = qnpMId;
    }
}